export const BOTTOM_TAB_BAR_AREA = 'BottomTabBar';

export const CLICK_BOTTOM_TAB_BAR_ITEM = {
  area: BOTTOM_TAB_BAR_AREA,
  action: 'ClickItem',
};
